/* RESPONSIBLE TEAM: team-ai-insights */

import { get } from 'embercom/lib/ajax';

type RepresentativeDoc = string;

export interface Topic {
  name: string;
  description: string | null;
  subtopics: {
    [subtopicName: string]: RepresentativeDoc[];
  };
}

export interface TopicTaxonomy {
  [key: string]: Topic;
}

interface SerializedSubtopic {
  topic_name: string;
  topic_description: string;
  subtopic_name: string;
  _subtopic_representative_docs: string[];
}

async function fetchTopicsTaxonomy(
  appId: any,
  syntheticDataUseCase: string | null,
  signal?: AbortSignal,
) {
  let response = (await get(
    '/ember/ai_insights/topics',
    {
      app_id: appId,
      synthetic_data_use_case: syntheticDataUseCase,
    },
    { signal },
  )) as { topics: SerializedSubtopic[] };

  let topics = {} as TopicTaxonomy;
  for (let entry of response.topics) {
    let topic = topics[entry.topic_name] || {
      name: entry.topic_name,
      description: entry.topic_description,
      subtopics: {},
    };

    // Add subtopic representative docs if available
    topic.subtopics[entry.subtopic_name] = entry._subtopic_representative_docs || [];

    topics[topic.name] = topic;
  }
  return topics;
}

export { fetchTopicsTaxonomy };
